import { IForm } from "lobbie";
import { useCallback, useMemo } from "react";

import { Button } from "react-bootstrap";
import { FiCheck, FiChevronRight } from "react-icons/fi";
import { useHistory } from "react-router";
import { calculateCompletionPercentageForm } from "src/components/shared/forms/utils";
import { ROUTES } from "src/constants";
import { EUserType } from "src/constants/user";

interface IProps {
    accountPublicUuid: string;
    forms: IForm[];
}

const PatientAppointmentForms: React.FC<IProps> = ({ accountPublicUuid, forms }) => {
    return (
        <div className="cy-patient-appointment-forms">
            {forms.map((form: IForm) => (
                <PatientAppointmentForm
                    key={form.id}
                    accountPublicUuid={accountPublicUuid}
                    form={form}
                />
            ))}
        </div>
    );
};

const PatientAppointmentForm: React.FC<{ accountPublicUuid: string; form: IForm }> = ({
    accountPublicUuid,
    form,
}) => {
    const { push } = useHistory();
    const navigate = useCallback(() => {
        push(ROUTES.formId(form.id, accountPublicUuid), {
            userType: EUserType.Patient,
        });
    }, [push, accountPublicUuid, form.id]);

    const percentComplete = useMemo(
        () => calculateCompletionPercentageForm(form, form.answers, EUserType.Patient).percentage,
        [form],
    );

    if (!form.formTemplateVersion) {
        return null;
    }

    return (
        <div
            className="row border rounded mb-3 shadow-sm cy-patient-appointment-form"
            onClick={navigate}
            key={form.id}
        >
            <div className="col p-3 mt-1 f-label">{form.formTemplateVersion.name}</div>
            <div className="col text-right p-2 mb-1">
                {percentComplete > 0 && !form.complete && (
                    <Button size="sm" variant="primary" className="mt-1 pr-1 py-2 pl-3">
                        <span className="fb-content mr-3">
                            {percentComplete + "%"}
                            <img src="/bar_complete.svg" alt="bar" className="ml-2" />
                            {percentComplete >= 50 && (
                                <img src="/bar_complete.svg" alt="bar" className="p-bar" />
                            )}
                            {percentComplete < 50 && (
                                <img src="/bar_incomplete.svg" alt="bar" className="p-bar" />
                            )}
                            <img src="/bar_incomplete.svg" alt="bar" className="p-bar mr-n2" />
                        </span>
                        <span className="separator ml-0"></span>
                        <span className="fb-content ml-1">
                            <FiChevronRight />
                        </span>
                    </Button>
                )}
                {percentComplete === 0 && (
                    <Button size="sm" variant="primary" className="mt-1 pr-1 py-2 pl-3">
                        <span className="fb-content mr-3">start</span>
                        <span className="separator"></span>
                        <span className="fb-content ml-1">
                            <FiChevronRight />
                        </span>
                    </Button>
                )}
                {form.complete && (
                    <Button size="sm" variant="light" className="mt-1 pr-1 py-2 pl-3">
                        <span className="fb-content mr-2">completed</span>
                        <span className="fb-content ml-0">
                            <FiCheck />
                        </span>
                    </Button>
                )}
            </div>
        </div>
    );
};

export default PatientAppointmentForms;
